module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show_) ? _c('div', {
    ref: "midea-overlay",
    staticClass: ["midea-overlay"],
    style: _vm.overlayStyle,
    on: {
      "click": _vm.overlayClicked
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-ce1075a6!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-overlay/index.vue
// module id = 657
// module chunks = 0 1